import {ConfigService} from '@services/infra/config.service';
import {environment} from '@environments/environment';

interface FrontendConfig {
  backend_url: string;
  log_url: string;
  order_sample_placeholder_text_users: string;
  baseHref: string;
}
export function loadConfig(configService: ConfigService) {
  console.log('loadenv');
  return () => {
    return new Promise<void>((resolve, reject) => {
      /* when in local mode, use the environment from the local file */
      if (environment.localConfig !== null) {
        console.log('not loading /config because we have a local config');
        configService.setConfig(environment.localConfig);
        resolve();
        return;
      }
      /* otherwise, perform an ajax call to the /config endpoint */
      const r = new XMLHttpRequest();
      r.onload = function () {
        const c = JSON.parse(this.response) as FrontendConfig;
        configService.setConfig({
          backendUrl: c.backend_url,
          logUrl: c.log_url,
          orderSamplePlaceholderTextUsers: c.order_sample_placeholder_text_users,
          baseHref: c.baseHref,
        });
        setTimeout(() => resolve(), 0); // IE compat hack
      };
      r.onerror = function () {
        reject(this.statusText);
      };
      r.open('GET', './config');
      r.timeout = 1000; // IE: has to set set AFTER r.open()
      r.send();
    });
  };
}
